import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ShieldAlertIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { TradingViewWidget } from './TradingViewWidget';
const EARTH_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/5b86738c-2ad3-46cf-a400-a754cde08084.jpg';
const CHART_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  details: false,
  hide_side_toolbar: true,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: false,
  hotlist: false,
  interval: 'D',
  locale: 'es',
  save_image: true,
  style: '1',
  symbol: 'OANDA:XAUUSD',
  theme: 'dark',
  timezone: 'America/New_York',
  backgroundColor: '#0F0F0F',
  gridColor: 'rgba(242, 242, 242, 0.2)',
  watchlist: [],
  withdateranges: false,
  compareSymbols: [],
  support_host: 'https://www.tradingview.com',
  studies: [],
  autosize: true
};
export function Hero() {
  const reduced = useReducedMotion();
  const fade = (delay: number) => reduced ? {} : {
    initial: {
      opacity: 0,
      y: 18
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  };
  return <section id="top" className="relative isolate overflow-hidden bg-brand-950" data-id="element-103" data-mp="39b4fyxmj3o1c">
      <img src={EARTH_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-top opacity-70" data-id="element-104" data-mp="3e963buqzm9im" />
      <div aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(180deg,rgba(16,31,140,0.94)_0%,rgba(11,22,104,0.82)_42%,rgba(6,13,61,0.92)_100%)]" data-id="element-105" data-mp="30g6mnpfgy99h" />

      <div className="relative mx-auto grid max-w-[1400px] items-center gap-12 px-5 pb-24 pt-32 sm:pt-40 lg:grid-cols-[1fr_1.02fr] lg:gap-14 lg:px-8 lg:pb-32" data-id="element-106" data-mp="2qlocq2jglhh8">
        <div data-id="element-107" data-mp="2hk8522k13tgp">
          <motion.p {...fade(0)} className="text-[11px] font-semibold uppercase tracking-overline text-brand-200" data-id="element-108" data-mp="2hkgh5s8buuqu">
            Trading • Markets • Opportunities
          </motion.p>

          <motion.h1 {...fade(0.06)} className="mt-6 text-[2.5rem] font-semibold leading-[1.04] tracking-[-0.025em] text-white sm:text-[3.4rem] lg:text-[4rem]" data-id="element-109" data-mp="s3cloaja7jqk">
            Tu próximo paso en el mercado{' '}
            <span className="text-brand-400" data-id="element-110" data-mp="ddnhs7jt11ml">comienza aquí.</span>
          </motion.h1>

          <motion.p {...fade(0.12)} className="mt-7 max-w-xl text-[15.5px] leading-relaxed text-white/70 sm:text-[17px]" data-id="element-111" data-mp="1b0njdqp9m53w">
            Descubre una experiencia de trading moderna y accede a una plataforma
            diseñada para traders que buscan explorar los mercados financieros con
            herramientas digitales y una experiencia profesional.
          </motion.p>

          <motion.div {...fade(0.18)} className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-112" data-mp="3ltglflt1eim8">
            <CTAButton label="Abrir mi cuenta" location="hero_primary" size="lg" data-id="element-113" data-mp="3hrllolqr8dak" />
            <CTAButton label="Conocer la plataforma" location="hero_secondary" variant="onDark" size="lg" withIcon={false} data-id="element-114" data-mp="3htpy5s2pykmg" />
          </motion.div>

          <motion.p {...fade(0.24)} className="mt-7 text-[12px] font-medium uppercase tracking-[0.12em] text-white/55" data-id="element-115" data-mp="269hci51r153a">
            Registro online • Acceso a la plataforma • Trading con riesgo
          </motion.p>

          <motion.p {...fade(0.28)} className="mt-4 flex items-start gap-2 text-[12.5px] leading-relaxed text-white/45" data-id="element-116" data-mp="2fziz0segefg3">
            <ShieldAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-white/40" aria-hidden="true" data-id="element-117" data-mp="2p08vlybjg9uv" />
            El trading implica riesgos y puede no ser adecuado para todos los
            inversores.
          </motion.p>
        </div>

        <motion.div initial={reduced ? undefined : {
        opacity: 0,
        scale: 0.97
      }} animate={reduced ? undefined : {
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-white/12 bg-white/[0.06] p-2 shadow-[0_40px_90px_-40px_rgba(0,0,0,0.8)] backdrop-blur-md" data-id="element-118" data-mp="zlaqw2ufk8nz">
          <div className="h-[380px] overflow-hidden rounded-xl sm:h-[460px]" data-id="element-119" data-mp="e77gdj6c13fw">
            <TradingViewWidget config={CHART_CONFIG} copyrightSymbol="XAUUSD" copyrightHref="https://www.tradingview.com/symbols/XAUUSD/?exchange=OANDA" data-id="element-120" data-mp="9b8rzvl07lfh" />
          </div>
        </motion.div>
      </div>
    </section>;
}